<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Principais problemas apontados pelos usuários.
                <a
                  data-toggle="collapse"
                  href="#collapseFilter"
                  aria-expanded="false"
                  aria-controls="collapseFilter"
                  class="btn-filter"
                >
                  Filtros
                  <i class="fas fa-filter"></i>
                </a>
              </div>
            </div>
            <div class="card-body">
              <div class="collapse" id="collapseFilter">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartDateStart">Data Início</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="filters.retreat_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartDateEnd">Data Final</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="filters.devolution_date"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn-add"
                      @click="getEntity()"
                    >
                      Filtrar
                    </button>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-md-8">
                  <chart-bar
                    :chartData="dash.graphics.problemsperiodPerUser"
                    :options="options"
                    v-if="loaded"
                  ></chart-bar>
                </div>
                <div class="col-md-10 mt-5">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Problema</th>
                        <th
                          scope="col"
                          v-for="column in dash.graphics.problemsperiodPerUser
                            .labels"
                          :key="column"
                        >
                          {{ column }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(line, index) in dash.graphics
                          .problemsperiodPerUser.datasets"
                        :key="line"
                      >
                        <th scope="row">{{ line.label }}</th>
                        <td
                          v-for="line in dash.graphics.problemsperiodPerUser
                            .datasets[index].data"
                          :key="line"
                        >
                          {{ line }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartBar from "../Utils/ChartBar";

export default {
  data() {
    return {
      filters: {
        retreat_date: "",
        devolution_date: "",
        branch_id: null,
      },
      loaded: false,
      dash: {
        graphics: {},
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
    };
  },
  methods: {
    getEntity() {
      let self = this;
      let api = self.$store.state.api + "main_items";

      self.loaded = false;
      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.dash = response.data;
          self.loaded = true;
        })
        .catch((error) => {
          self.errors = error.reponse.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted() {
    const self = this;

    self.getEntity();
  },
  components: { ChartBar },
};
</script>

<style scoped>
.card {
  margin-bottom: 1, 5rem;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 0, 5rem;
}
.card-body {
  padding: 10px;
}
.card-small-info {
  text-align: justify;
}
.card-value-info {
  font-size: 20px;
  font-weight: 700;
}
.card-value-info span {
  font-size: 20px;
}
.card-icon {
  position: absolute;
  bottom: -10px;
  right: -10px;
  font-size: 90px;
  color: #08b9b3;
  opacity: 0.1;
  z-index: 0;
}
.card-percent.up {
  color: #28a745;
  font-size: 11px;
}
.card-percent.up::before {
  font-family: "Font Awesome 5 Free";
  content: "\f30c";
  font-weight: 700;
  margin-right: 3px;
}
.card-percent.down {
  color: #bb0034;
  font-size: 11px;
}
.card-percent.down::before {
  font-family: "Font Awesome 5 Free";
  content: "\f309";
  font-weight: 700;
  margin-right: 3px;
}
.b {
  font-weight: bold;
}
.title-graphic {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Indicators/main_items.vue